import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import useHistory from "routing/useHistory";
import Routes from "routing/Routes";
import { MetricContainer, CounterRate } from "components/metrics";
import ErrorPopover from "components/lookup-tables/ErrorPopover";
import { useErrorsContext } from "components/lookup-tables/contexts/ErrorsContext";
const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
const Title = styled.div`
  color: ${({ theme }) => theme.colors.link.default};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.link.hover};
    text-decoration: underline;
  }
`;
const TitleCol = ({ adapter, children }) => {
  const { errors } = useErrorsContext();
  const adapterErrorText = errors == null ? void 0 : errors.adapterErrors[adapter.name];
  const { push } = useHistory();
  const onClick = useCallback(() => {
    push(Routes.SYSTEM.LOOKUPTABLES.DATA_ADAPTERS.show(adapter == null ? void 0 : adapter.name));
  }, [push, adapter == null ? void 0 : adapter.name]);
  return /* @__PURE__ */ React.createElement(TitleRow, null, adapterErrorText && /* @__PURE__ */ React.createElement(ErrorPopover, { placement: "right", errorText: adapterErrorText, title: "Data Adapter problem" }), /* @__PURE__ */ React.createElement(Title, { onClick }, children));
};
const ThroughputCol = ({ adapter }) => /* @__PURE__ */ React.createElement(MetricContainer, { name: `org.graylog2.lookup.adapters.${adapter.id}.requests` }, /* @__PURE__ */ React.createElement(CounterRate, { suffix: "lookups/s" }));
const columnRenderers = {
  attributes: {
    title: {
      renderCell: (title, adapter) => /* @__PURE__ */ React.createElement(TitleCol, { adapter }, title)
    },
    description: {
      renderCell: (description) => /* @__PURE__ */ React.createElement("span", null, description)
    },
    name: {
      staticWidth: 200,
      renderCell: (name) => /* @__PURE__ */ React.createElement("span", null, name)
    },
    throughput: {
      staticWidth: 130,
      renderCell: (_arg, adapter) => /* @__PURE__ */ React.createElement(ThroughputCol, { adapter }),
      textAlign: "right"
    }
  }
};
export default columnRenderers;
